// src/router/index.js
import {createRouter, createWebHistory} from 'vue-router';
import store from "@/store";

const adminLayout = () => import('../components/adminLayout/index.vue')

const routes = [
    {
        path: '/admin',
        name: 'adminLayout',
        component: adminLayout,
        redirect: '/admin/index',
        children: [
            {
                path: 'index',
                name: 'index',
                component: () => import('../view/admin/home/index.vue'),
                meta: { title: '首页', icon: 'house' }
            },
            {
                path: 'user',
                name: 'user',
                component: () => import('../view/admin/user/index.vue'),
                meta: { title: '用户管理', icon: 'user' }
            },
            {
                path: 'shop',
                name: 'shop',
                component: () => import('../view/admin/shop/index.vue'),
                meta: { title: '店铺管理', icon: 'shop' }
            },
            {
                path: 'order',
                name: 'order',
                redirect: '/admin/order/list',
                meta: { title: '订单管理', icon: 'tickets' },
                children: [
                    {
                        path: 'list',
                        name: 'orderList',
                        component: () => import('../view/admin/order/list/index.vue'),
                        meta: { title: 'FBM订单', icon: 'tickets' }
                    },
                    {
                        path: 'fba',
                        name: 'fbaOrder',
                        component: () => import('../view/admin/fba/order/index.vue'),
                        meta: { title: 'FBA订单', icon: 'tickets' }
                    },
                    {
                        path: 'unbound',
                        name: 'orderUnbound',
                        component: () => import('../view/admin/order/unbound/index.vue'),
                        meta: { title: '未绑定订单', icon: 'warning' }
                    },
                    {
                        path: 'cost-snapshot',
                        name: 'orderCostSnapshot',
                        component: () => import('../view/admin/order/costSnapshot/index.vue'),
                        meta: { title: '订单成本快照', icon: 'documentCopy' }
                    }
                ]
            },
            {
                path: 'product',
                name: 'product',
                redirect: '/admin/product/list',
                meta: { title: '商品管理', icon: 'goods' },
                children: [
                    {
                        path: 'list',
                        name: 'productList',
                        component: () => import('../view/admin/product/list/index.vue'),
                        meta: { title: '商品列表', icon: 'goods' }
                    },
                    {
                        path: 'platform-info',
                        name: 'productPlatformInfo',
                        component: () => import('../view/admin/product/platformInfo/index.vue'),
                        meta: { title: '产品信息', icon: 'goods' }
                    },
                    {
                        path: 'supplier',
                        name: 'supplierList',
                        component: () => import('../view/admin/product/supplier/index.vue'),
                        meta: { title: '供应商列表', icon: 'van' }
                    },
                    {
                        path: 'supplier-relation',
                        name: 'productSupplierRelation',
                        component: () => import('../view/admin/product/supplierRelation/index.vue'),
                        meta: { title: '商品供应商关系', icon: 'connection' }
                    }
                ]
            },
            {
                path: 'sku-bind',
                name: 'skuBind',
                redirect: '/admin/sku-bind/list',
                meta: { title: 'SKU绑定管理', icon: 'link' },
                children: [
                    {
                        path: 'list',
                        name: 'skuBindList',
                        component: () => import('../view/admin/skuBind/list/index.vue'),
                        meta: { title: '平台SKU绑定', icon: 'link' }
                    },
                    {
                        path: 'asin-consumable',
                        name: 'asinConsumableBind',
                        component: () => import('../view/admin/skuBind/asinConsumable/index.vue'),
                        meta: { title: 'ASIN耗材绑定', icon: 'connection' }
                    },
                    {
                        path: 'history',
                        name: 'skuBindHistory',
                        component: () => import('../view/admin/skuBind/history/index.vue'),
                        meta: { title: '绑定历史', icon: 'clock' }
                    }
                ]
            },
            {
                path: 'profit',
                name: 'profit',
                redirect: '/admin/profit/order-profit',
                meta: { title: '利润管理', icon: 'trendCharts' },
                children: [
                    {
                        path: 'exchange-rate',
                        name: 'exchangeRate',
                        component: () => import('../view/admin/profit/exchangeRate/index.vue'),
                        meta: { title: '汇率管理', icon: 'coin' }
                    },
                    {
                        path: 'order-profit',
                        name: 'orderProfit',
                        component: () => import('../view/admin/profit/orderProfit/index.vue'),
                        meta: { title: 'FBM利润', icon: 'trendCharts' }
                    },
                    {
                        path: 'fba-profit',
                        name: 'fbaProfit',
                        component: () => import('../view/admin/fba/profit/index.vue'),
                        meta: { title: 'FBA利润', icon: 'trendCharts' }
                    },
                    {
                        path: 'exception',
                        name: 'profitException',
                        component: () => import('../view/admin/profit/exception/index.vue'),
                        meta: { title: '利润异常订单', icon: 'warning' }
                    }
                ]
            },
            {
                path: 'logistics',
                name: 'logistics',
                redirect: '/admin/logistics/status',
                meta: { title: '物流管理', icon: 'position' },
                children: [
                    {
                        path: 'status',
                        name: 'logisticsStatus',
                        component: () => import('../view/admin/logistics/status/index.vue'),
                        meta: { title: '物流状态标记', icon: 'location' }
                    },
                    {
                        path: 'shipping-cost',
                        name: 'shippingCost',
                        component: () => import('../view/admin/logistics/shippingCost/index.vue'),
                        meta: { title: '运费成本录入', icon: 'money' }
                    },
                    {
                        path: 'channel-rate',
                        name: 'logisticsChannelRate',
                        component: () => import('../view/admin/logistics/channelRate/index.vue'),
                        meta: { title: '物流渠道管理', icon: 'van' }
                    }
                ]
            },
            {
                path: 'inventory',
                name: 'inventory',
                redirect: '/admin/inventory/warehouse',
                meta: { title: '库存采购', icon: 'box' },
                children: [
                    {
                        path: 'warehouse',
                        name: 'warehouse',
                        component: () => import('../view/admin/inventory/warehouse/index.vue'),
                        meta: { title: '仓库管理', icon: 'house' }
                    },
                    {
                        path: 'fbm',
                        name: 'fbmInventoryGroup',
                        redirect: '/admin/inventory/fbm/stock',
                        meta: { title: 'FBM管理', icon: 'box' },
                        children: [
                            {
                                path: 'stock',
                                alias: '/admin/inventory/stock',
                                name: 'inventoryStock',
                                component: () => import('../view/admin/inventory/stock/index.vue'),
                                meta: { title: '库存汇总', icon: 'box' }
                            },
                            {
                                path: 'flow',
                                alias: '/admin/inventory/flow',
                                name: 'inventoryFlow',
                                component: () => import('../view/admin/inventory/flow/index.vue'),
                                meta: { title: '库存流水', icon: 'list' }
                            },
                            {
                                path: 'purchase-order',
                                alias: '/admin/inventory/purchase-order',
                                name: 'purchaseOrder',
                                component: () => import('../view/admin/inventory/purchaseOrder/index.vue'),
                                meta: { title: '采购单列表', icon: 'shoppingCart' }
                            }
                        ]
                    },
                    {
                        path: 'fba',
                        name: 'fbaInventoryGroup',
                        redirect: '/admin/inventory/fba/inbound',
                        meta: { title: 'FBA管理', icon: 'box' },
                        children: [
                            {
                                path: 'inbound',
                                alias: '/admin/inventory/fba-inbound',
                                name: 'fbaInbound',
                                component: () => import('../view/admin/fba/inbound/index.vue'),
                                meta: { title: 'FBA入库', icon: 'box' }
                            },
                            {
                                path: 'inventory',
                                alias: '/admin/inventory/fba-inventory',
                                name: 'fbaInventory',
                                component: () => import('../view/admin/fba/inventory/index.vue'),
                                meta: { title: 'FBA库存', icon: 'box' }
                            },
                            {
                                path: 'inventory-flow',
                                alias: '/admin/inventory/fba-inventory-flow',
                                name: 'fbaInventoryFlow',
                                component: () => import('../view/admin/fba/inventory/flow.vue'),
                                meta: { title: 'FBA库存流水', icon: 'list' }
                            }
                        ]
                    },
                    {
                        path: 'consumables',
                        name: 'consumableInventoryGroup',
                        redirect: '/admin/inventory/consumables/stock',
                        meta: { title: '耗材管理', icon: 'box' },
                        children: [
                            {
                                path: 'stock',
                                alias: '/admin/inventory/consumable',
                                name: 'consumable',
                                component: () => import('../view/admin/inventory/consumable/index.vue'),
                                meta: { title: '耗材库存汇总', icon: 'box' }
                            },
                            {
                                path: 'purchase-order',
                                alias: '/admin/inventory/consumable-purchase-order',
                                name: 'consumablePurchaseOrder',
                                component: () => import('../view/admin/inventory/consumablePurchaseOrder/index.vue'),
                                meta: { title: '耗材采购单', icon: 'shoppingCart' }
                            }
                        ]
                    }
                ]
            },

            {
                path: 'report',
                name: 'report',
                redirect: '/admin/report/unified',
                meta: { title: '报表中心', icon: 'dataAnalysis' },
                children: [
                    {
                        path: 'unified',
                        name: 'unifiedReport',
                        component: () => import('../view/admin/report/unified/index.vue'),
                        meta: { title: '经营汇总', icon: 'dataAnalysis' }
                    },
                    {
                        path: 'statements',
                        name: 'reportStatementGroup',
                        redirect: '/admin/report/statements/monthly-expense',
                        meta: { title: '报表与明细', icon: 'dataAnalysis' },
                        children: [
                            {
                                path: 'monthly-expense',
                                alias: '/admin/report/monthly-expense',
                                name: 'monthlyExpense',
                                component: () => import('../view/admin/report/monthlyExpense/index.vue'),
                                meta: { title: '月度费用明细', icon: 'money' }
                            },
                            {
                                path: 'monthly-profit',
                                alias: '/admin/report/monthly-profit',
                                name: 'monthlyProfit',
                                component: () => import('../view/admin/report/monthlyProfit/index.vue'),
                                meta: { title: '月度利润报表', icon: 'dataAnalysis' }
                            },
                            {
                                path: 'yearly-profit',
                                alias: '/admin/report/yearly-profit',
                                name: 'yearlyProfit',
                                component: () => import('../view/admin/report/yearlyProfit/index.vue'),
                                meta: { title: '年度利润报表', icon: 'dataLine' }
                            }
                        ]
                    },
                    {
                        path: 'conversions',
                        name: 'reportConversionGroup',
                        redirect: '/admin/report/conversions/settlement',
                        meta: { title: '账单转换', icon: 'document' },
                        children: [
                            {
                                path: 'settlement',
                                alias: '/admin/report/settlement-convert',
                                name: 'settlementConvert',
                                component: () => import('../view/admin/report/settlementConvert/index.vue'),
                                meta: { title: '后台账单转换', icon: 'document' }
                            },
                            {
                                path: 'purchase',
                                alias: '/admin/report/purchase-convert',
                                name: 'purchaseConvert',
                                component: () => import('../view/admin/report/purchaseConvert/index.vue'),
                                meta: { title: '采购账单转换', icon: 'document' }
                            },
                            {
                                path: 'logistics',
                                alias: '/admin/report/logistics-convert',
                                name: 'logisticsConvert',
                                component: () => import('../view/admin/report/logisticsConvert/index.vue'),
                                meta: { title: '物流账单转换', icon: 'document' }
                            }
                        ]
                    }
                ]
            },
            {
                path: 'userMenu',
                name: 'userMenu',
                component: () => import('../view/admin/userMenu/index.vue'),
                meta: { title: '用户权限管理', icon: 'user' }
            },
            {
                path: 'resource',
                name: 'resource',
                component: () => import('../view/admin/resource/index'),
                meta: { title: '资源管理', icon: 'paperclip' }
            },
            {
                path: 'log',
                name: 'log',
                redirect: '/admin/log/operation',
                meta: { title: '日志管理', icon: 'notebook' },
                children: [
                    {
                        path: 'operation',
                        name: 'operation',
                        component: () => import('../view/admin/log/operation/index.vue'),
                        meta: { title: '操作日志', icon: 'document' }
                    },
                    {
                        path: 'loginLog',
                        name: 'loginLog',
                        component: () => import('../view/admin/log/loginLog/index.vue'),
                        meta: { title: '登录日志', icon: 'key' }
                    },
                ]
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../view/login/index.vue'),
        meta: { title: '登录' }
    },
    { path: '/', redirect: '/admin/index' },
    { path: '/404', name: '404', component: () => import('../view/404/index.vue') },
    { path: '/:pathMatch(.*)*', redirect: '/404' }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from) => {
    if (to.path.startsWith('/admin')) {
        const userInfo = store.getters['user/userInfo']
        if (!store.getters['user/isLogin']) {
            return {path: '/login', query: {redirect: to.fullPath}}
        }
        if (!userInfo || userInfo.level !== 1) {
            return {path: '/login'}
        }
    }
    return true
})

router.afterEach((to, from) => {
    if (to.path !== from.path) {
        window.scrollTo({top: 0, behavior: 'smooth'})
    }
})

export {routes as staticRoutes};
export default router;
